import {
  prospectsRequest,
  prospectsSuccess,
  prospectsFailure,
  postGenerateRouteRequest,
  postGenerateRouteSuccess,
  postGenerateRouteFailure,
} from './actionCreators';

import {
  generateRoute,
  getProspects,
} from './api.service';

export const fetchProspects = (query) => async (dispatch) => {
  try {
    dispatch(prospectsRequest());
    const { data } = await getProspects(query);
    dispatch(prospectsSuccess(data.data, { ...query, ...data.meta }));
  } catch ({ message }) {
    dispatch(prospectsFailure(message));
  }
};

export const postGenerateRoute = (data) => async (dispatch) => {
  try {
    dispatch(postGenerateRouteRequest());
    await generateRoute(data);
    dispatch(postGenerateRouteSuccess('Canvass Route has been successfully generated'));
  } catch ({ message }) {
    dispatch(postGenerateRouteFailure(message));
  }
};
